export default "Capitalism! Hell yeah!";